import { HOSTED_RUNTIME_LABEL } from '@/core/const/hostedRuntimeLabel.const'
import { Runtime } from '@/core/enums/runtime.enum'

export const formatRuntimePhrase = (runtimeName: Runtime, runtimeVersion: string): string => {
  const label = HOSTED_RUNTIME_LABEL[runtimeName] ?? runtimeName
  const version = runtimeVersion.trim()

  if (/^(java|python|ruby|php|node|\.net|dotnet)\b/i.test(version)) {
    return version
  }

  const tfmMatch = version.match(/Version=v([\d.]+)/i)
  if (runtimeName === Runtime.Netcore && tfmMatch) {
    return `.NET ${tfmMatch[1]}`
  }

  return `${label} ${version}`
}
